export const getIsDueNow = (
  shouldUpgradeSubscriptionImmediately: boolean,
  nextBillAt?: string | null
) => {
  const today = new Date().toISOString();
  const isCurrentDateBillingDate = Boolean(today === nextBillAt) ?? true;
  const isDueNow =
    isCurrentDateBillingDate || shouldUpgradeSubscriptionImmediately;
  return isDueNow;
};
